import { render, staticRenderFns } from "./DetachNeopassPopup.vue?vue&type=template&id=285474e0&"
import script from "./DetachNeopassPopup.vue?vue&type=script&lang=js&"
export * from "./DetachNeopassPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports